import styled from 'styled-components';

export const CounterDiv = styled.div`
  width: 100%;
`;
